module.exports = __webpack_public_path__ + "img/member08.ef5c0ba8.png";